const initPricingContainer = (pricingContainer) => {
    const items = pricingContainer.querySelectorAll('.m-pricing__body .m-pricing__item');
    items.forEach((item) => {
        item.addEventListener('click', (event) => {
            items.forEach((currentItem) => currentItem.classList.toggle('active', currentItem === item));
        });
    });
};
export const initPricingBoxes = () => {
    const pricingContainers = document.querySelectorAll('.m-pricing--default');
    pricingContainers.forEach((pricingContainer) => initPricingContainer(pricingContainer));
};
